import { Routes } from '@angular/router';

import { DuplicateTabGuard } from './core/guards/duplicate-tab.guard';
import { AuthGuard } from './guards/auth.guard';
import { MobileGuard } from './guards/mobile.guard';
import { OnboardingEntryGuard, OnboardingGuard } from './guards/onboarding.guard';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        path: 'mobile-wip',
        loadComponent: () => import('./mobile-wip/mobile-wip.component').then(m => m.MobileWipComponent),
        title: 'Mobile App Coming Soon'
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then(m => m.AuthRoutes)
    },
    {
        path: 'duplicate-tab',
        loadComponent: () => import('./features/duplicate-tab/duplicate-tab.component').then(m => m.DuplicateTabComponent),
        title: 'Duplicate Tab'
    },
    {
        path: 'no-workspace',
        canMatch: [DuplicateTabGuard],
        canActivate: [MobileGuard],
        loadComponent: () => import('./home/pages/no-workspace/no-workspace.component').then(m => m.NoWorkspaceComponent),
        title: 'No Workspace Access'
    },
    {
        path: 'onboarding',
        canMatch: [DuplicateTabGuard, OnboardingEntryGuard],
        canActivate: [AuthGuard],
        loadComponent: () => import('./onboarding/onboarding-wizard.component').then(m => m.OnboardingWizardComponent),
        title: 'Get Started'
    },
    {
        path: 'home',
        canMatch: [DuplicateTabGuard],
        canActivate: [AuthGuard, OnboardingGuard],
        loadChildren: () => import('./home/home.routes').then(m => m.HomeRoutes)
    },
    {
        path: 'widget',
        canMatch: [DuplicateTabGuard],
        loadComponent: () => import('./widget-host/widget-host.component').then(m => m.WidgetComponent),
        title: 'Widget'
    },
    {
        path: '**',
        loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent)
    }
];
